import React from "react";
import Moment from "react-moment";
import ReactHtmlParser from 'react-html-parser'

function LogRows(props) {
  const renderLog = () => {
    let rows = props.notes.map((note, index) => {
      return (
        <tr key={note.modified + index}>
          <td>
          <Moment format="DD/MM/YYYY">{note.modified}</Moment>
          </td>
          <td>
            {ReactHtmlParser(note.message)}
          </td>
          <td>
            {note.author}
          </td>
        </tr>
      )
    })
    return rows;
  }

  return (
      renderLog()
  )
}


export default LogRows;
